import React from "react";
import { TOUCH_FEEDBACK_STYLE } from "../../../../constants/secondaryCamera";

// Was identical in InstructionSlide and PositioningSlide — now one component.
const WizardBackButton = ({ onClick, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    style={TOUCH_FEEDBACK_STYLE}
    className={`px-6 py-3 rounded-full font-medium text-white border border-gray-700/50 bg-gray-800/50 transition-transform ${
      disabled ? "opacity-40 cursor-not-allowed" : "hover:bg-gray-700/50 active:bg-gray-700/70 active:scale-95"
    }`}
  >
    Back
  </button>
);

export default WizardBackButton;
